/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-02-28 14:26:06
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-03-01 16:04:18
 * @FilePath: \renying\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    redirect: '/map',
    children: [
      // 子路由将在这里添加
      {
        path: '/map',
        name: 'map',
        component: () => import(/* webpackChunkName: "map" */ '../views/MapView.vue')
      },
      {
        path: '/warning',
        name: 'warning',
        component: () => import(/* webpackChunkName: "warning" */ '../views/WarningView.vue')
      },
      {
        path: '/analysis',
        name: 'analysis',
        component: () => import(/* webpackChunkName: "analysis" */ '../views/AnalysisView.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
